import { AvatarSize } from './types';

export const avatarSizePx = {
    [AvatarSize.Smallest]: 32,
    [AvatarSize.Smaller]: 40,
    [AvatarSize.Small]: 90,
    [AvatarSize.Medium]: 140,
    [AvatarSize.Large]: 160,
    [AvatarSize.Larger]: 240,
};

export const badgeSizePx = {
    [AvatarSize.Smallest]: 12,
    [AvatarSize.Smaller]: 16,
    [AvatarSize.Small]: 20,
    [AvatarSize.Medium]: 32,
    [AvatarSize.Large]: 40,
    [AvatarSize.Larger]: 64,
};
